import { TaskHeaderMapping } from "./taskHeaderMenuMapping";

type PermissionMapping = {
    [key: string]: {
      controller: string;
      function: string;
    };
  };

// Merge both mappings
  const PERMISSION_MAPPINGS: PermissionMapping = {
    ...TaskHeaderMapping,

  };
  
  export function getPermissionMapping(key: string) {
    return PERMISSION_MAPPINGS[key] || null;
  }